import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  List,
  ListItem,
  Avatar,
  Rating,
  Button,
  Divider,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';


const GoogleReviewsModal = ({ open, onClose, shopName, shopId, placeId, reviews, loading }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxHeight: '80vh',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          bgcolor: '#f8f9fa',
          borderBottom: '1px solid #e0e0e0',
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {shopName} - Customer Reviews
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 8 }}>
            <CircularProgress />
          </Box>
        ) : !reviews || reviews.length === 0 ? (
          <Box sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="body1" color="text.secondary">
              No reviews available yet.
            </Typography>
          </Box>
        ) : (
          <>
            <List sx={{ p: 2 }}>
              {reviews.map((review, index) => (
                <React.Fragment key={review.id || index}>
                  <ListItem
                    alignItems="flex-start"
                    sx={{
                      flexDirection: 'column',
                      px: 0,
                      py: 2,
                    }}
                  >
                    <Box sx={{ display: 'flex', width: '100%', mb: 1 }}>
                      <Avatar
                        sx={{ mr: 2, width: 40, height: 40 }}
                      >
                        {review.first_name?.[0] || '?'}
                      </Avatar>
                      <Box sx={{ flex: 1 }}>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            mb: 0.5,
                          }}
                        >
                          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                            {review.first_name} {review.last_name}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {new Date(review.created_at).toLocaleDateString()}
                          </Typography>
                        </Box>
                        <Rating value={review.rating} size="small" readOnly sx={{ mb: 1 }} />
                        {review.comment && (
                          <Typography variant="body2" sx={{ color: '#333', lineHeight: 1.6 }}>
                            {review.comment}
                          </Typography>
                        )}
                        <Box
                          sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            mt: 1,
                            px: 1,
                            py: 0.5,
                            bgcolor: 'rgba(66, 133, 244, 0.1)',
                            borderRadius: 1,
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{ color: '#4285F4', fontWeight: 500 }}
                          >
                            Google Review
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </ListItem>
                  {index < reviews.length - 1 && <Divider />}
                </React.Fragment>
              ))}
            </List>

            {/* See more on Google link */}
            {placeId && (
              <Box
                sx={{
                  p: 2,
                  borderTop: '1px solid #e0e0e0',
                  bgcolor: '#f8f9fa',
                  textAlign: 'center',
                }}
              >
                <Button
                  variant="text"
                  href={`https://search.google.com/local/reviews?placeid=${placeId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: '#4285F4',
                    textTransform: 'none',
                    fontWeight: 600,
                    '&:hover': {
                      backgroundColor: 'rgba(66, 133, 244, 0.1)',
                    },
                  }}
                >
                  See more reviews on Google →
                </Button>
              </Box>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default GoogleReviewsModal;

